import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Assets = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <g>
      <g transform="translate(3 8)">
        <rect width="3" height="9" x="10" y="4" rx="1" transform="matrix(-1 0 0 1 23 0)" />
        <rect width="3" height="13" x="15" rx="1" transform="matrix(-1 0 0 1 33 0)" />
        <rect width="3" height="4" x="5" y="9" rx="1" transform="matrix(-1 0 0 1 13 0)" />
        <rect width="3" height="4" y="9" rx="1" transform="matrix(-1 0 0 1 3 0)" />
      </g>
      <rect width="24" height="2" y="22" rx="1" />
      <path
        fillRule="nonzero"
        d="M7.292 6.854c-.876-.21-1.452-.373-1.452-.68 0-.412.48-.7 1.168-.7.9 0 1.55.403 1.856.779a.5.5 0 0 0 .803-.039l.547-.82a.5.5 0 0 0-.06-.628C9.586 4.19 8.848 3.803 8 3.632V2c0-.551-.449-1-1-1-.551 0-1 .449-1 1v1.628c-1.391.318-2.297 1.313-2.297 2.578 0 1.981 1.874 2.421 3.131 2.716 1.039.259 1.528.424 1.528.818 0 .751-.978.81-1.277.81-.91 0-1.709-.46-2.097-.913a.5.5 0 0 0-.788.034l-.607.852a.5.5 0 0 0 .04.631c.61.656 1.405 1.075 2.367 1.25V14a1.001 1.001 0 0 0 2 0v-1.586c1.534-.295 2.5-1.321 2.5-2.705 0-2.119-1.931-2.562-3.208-2.855Z"
      />
    </g>
  </SvgIcon>
);

export default Assets;
